// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZDxom","title":"styles_title__T2WMZ"};